import { useState } from "react";

/* SVG icons (kept inline to avoid extra files) */
const IcDash = (p) => (
  <svg viewBox="0 0 16 16" fill="none" {...p}>
    <rect x="2" y="2" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.4"/>
    <rect x="9" y="2" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.4"/>
    <rect x="2" y="9" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.4"/>
    <rect x="9" y="9" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.4"/>
  </svg>
);
const IcTraining = (p) => (
  <svg viewBox="0 0 16 16" fill="none" {...p}>
    <path d="M3 2.5h7l3 3v8.5H3z" stroke="currentColor" strokeWidth="1.4"/>
    <path d="M10 2.5v3h3" stroke="currentColor" strokeWidth="1.4"/>
  </svg>
);
const IcClassify = (p) => (
  <svg viewBox="0 0 16 16" fill="none" {...p}>
    <path d="M8 2l5.2 3v6L8 14 2.8 11V5z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
  </svg>
);
const IcModels = (p) => (
  <svg viewBox="0 0 16 16" fill="none" {...p}>
    <circle cx="4" cy="4" r="1.6" stroke="currentColor" strokeWidth="1.4"/>
    <circle cx="12" cy="8" r="1.6" stroke="currentColor" strokeWidth="1.4"/>
    <circle cx="4" cy="12" r="1.6" stroke="currentColor" strokeWidth="1.4"/>
    <path d="M5.5 4h5M5.5 12h5M5 5l5.5 2M5 11l5.5-2" stroke="currentColor" strokeWidth="1.3"/>
  </svg>
);
const IcSettings = (p) => (
  <svg viewBox="0 0 16 16" fill="none" {...p}>
    <circle cx="8" cy="8" r="2.2" stroke="currentColor" strokeWidth="1.4"/>
    <path d="M8 2v1.5M8 12.5V14M2 8h1.5M12.5 8H14M3.5 3.5l1.1 1.1M11.4 11.4l1.1 1.1M3.5 12.5l1.1-1.1M11.4 4.6l1.1-1.1"
      stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
  </svg>
);

const NAV = [
  { id: "dashboard",  group: "Main",     label: "Dashboard",        Ic: IcDash },
  { id: "training",   group: "Main",     label: "Document Training", Ic: IcTraining },
  { id: "classify",   group: "Main",     label: "IDP Classification", Ic: IcClassify },
  { id: "models",     group: "Main",     label: "Models",           Ic: IcModels },
  { id: "settings",   group: "Settings", label: "Settings",         Ic: IcSettings, disabled: true },
];

const TITLES = {
  dashboard: "Dashboard",
  training: "Document Training",
  classify: "IDP Classification",
  models: "Models",
  settings: "Settings",
};

const FileIc = () => (
  <svg className="job__file-ic" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M4 1.5h5.5L13 5v9.5H4z" stroke="currentColor" strokeWidth="1.3" />
    <path d="M9.5 1.5V5H13" stroke="currentColor" strokeWidth="1.3" />
  </svg>
);

/* ──────────────────────────────────────────────────────────────
   Views (each one is a CSS-only mockup, Meridian palette only)
   ────────────────────────────────────────────────────────────── */

function DashboardView() {
  return (
    <div className="wv">
      <div className="wv-kpis">
        <div className="wv-kpi"><div className="wv-kpi__num">8,240</div><div className="wv-kpi__lab">Jobs · 30d</div><div className="wv-kpi__chg">▲ 12.4%</div></div>
        <div className="wv-kpi"><div className="wv-kpi__num">79%</div><div className="wv-kpi__lab">Auto-approved</div><div className="wv-kpi__chg">▲ 5.1%</div></div>
        <div className="wv-kpi"><div className="wv-kpi__num">312</div><div className="wv-kpi__lab">Needs review</div><div className="wv-kpi__chg down">▼ 8.0%</div></div>
        <div className="wv-kpi"><div className="wv-kpi__num">14</div><div className="wv-kpi__lab">Active models</div><div className="wv-kpi__chg">▲ 2</div></div>
      </div>
      <div className="wv-block">
        <div className="wv-block__head">
          <span>Pipeline distribution</span>
          <span className="wv-block__meta">8,240 jobs</span>
        </div>
        <div className="wv-segbar"><i style={{width:"54%", background:"#3E86B5"}}/><i style={{width:"21%", background:"var(--teal-soft)"}}/><i style={{width:"14%", background:"#5FB58C"}}/><i style={{width:"11%", background:"#5C7790"}}/></div>
        <div className="wv-legend">
          <span><i style={{background:"#3E86B5"}}/>Extracted</span>
          <span><i style={{background:"var(--teal-soft)"}}/>In review</span>
          <span><i style={{background:"#5FB58C"}}/>Delivered</span>
          <span><i style={{background:"#5C7790"}}/>Processing</span>
        </div>
      </div>
      <div className="wv-block">
        <div className="wv-block__head"><span>Recent activity</span><span className="wv-block__meta">Today</span></div>
        <div className="wv-activity">
          <div className="wv-act"><FileIc /><div><b>INV-20418.pdf</b><span>Invoice model, auto-approved at 98.6%</span></div><span className="pill pill--ok">Delivered</span></div>
          <div className="wv-act"><FileIc /><div><b>claim_4471.pdf</b><span>Claims model, 1 field flagged at 63%</span></div><span className="pill pill--warn">Review</span></div>
          <div className="wv-act"><FileIc /><div><b>vendor-batch-07.pdf</b><span>Split into 3 documents across 11 pages</span></div><span className="pill pill--info">Classified</span></div>
        </div>
      </div>
    </div>
  );
}

function TrainingView() {
  return (
    <div className="empty wv">
      <div className="empty-illus" aria-hidden="true">
        <div className="doc"><i /><i /><i /><i /><i /><i /><i /></div>
        <div className="core">
          <svg viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="3.2" stroke="currentColor" strokeWidth="1.6"/>
            <path d="M12 4v3M12 17v3M4 12h3M17 12h3M6 6l2.1 2.1M15.9 15.9 18 18M6 18l2.1-2.1M15.9 8.1 18 6"
              stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
          </svg>
        </div>
        <div className="field">Claimant name</div>
        <div className="field">Invoice total</div>
        <div className="field">Line items</div>
        <div className="field">Date of issue</div>
        <svg className="wire" viewBox="0 0 420 170" preserveAspectRatio="none">
          <path d="M120 32 Q 180 32 188 80" />
          <path d="M120 66 Q 180 66 192 86" />
          <path d="M120 100 Q 180 100 196 92" />
          <path d="M120 134 Q 180 134 192 98" />
          <path d="M232 80 Q 270 60 300 26" />
          <path d="M232 86 Q 270 70 300 60" />
          <path d="M232 92 Q 270 100 300 94" />
          <path d="M232 98 Q 270 120 300 128" />
        </svg>
      </div>
      <h4>Train your first model in three steps.</h4>
      <p>Pick a document type, upload a handful of samples, identify the fields that matter. Publish, and Docket starts processing on day one.</p>
      <div className="empty__steps">
        <div className="empty__step"><b>1</b><h5>Upload samples</h5><span>Three or more documents</span></div>
        <div className="empty__step"><b>2</b><h5>Define fields</h5><span>What you need pulled out</span></div>
        <div className="empty__step"><b>3</b><h5>Annotate, review</h5><span>Confirm the boundaries</span></div>
      </div>
    </div>
  );
}

function ClassifyView() {
  const incoming = [
    { name: "supplier-batch-12.pdf", meta: "11 pages, scanned" },
    { name: "claims-form-228.pdf", meta: "4 pages" },
    { name: "BOL-88122.pdf", meta: "2 pages" },
  ];
  const matches = [
    [
      { type: "Invoice", pages: "pp. 1–4", conf: "97.3%", tone: "ok" },
      { type: "Purchase Order", pages: "pp. 5–8", conf: "95.1%", tone: "ok" },
      { type: "Covering Letter", pages: "pp. 9–11", conf: "92.6%", tone: "ok" },
    ],
    [{ type: "Claims form", pages: "pp. 1–4", conf: "94.4%", tone: "ok" }],
    [{ type: "Bill of Lading", pages: "pp. 1–2", conf: "96.1%", tone: "ok" }],
  ];
  return (
    <div className="wv wv-classify">
      <div className="wv-block">
        <div className="wv-block__head"><span>Incoming, last 15 minutes</span><span className="wv-block__meta">3 files, 7 documents</span></div>
        <div className="wv-class-list">
          {incoming.map((f, i) => (
            <div className="wv-class-row" key={f.name}>
              <div className="wv-class-src">
                <FileIc />
                <div><b>{f.name}</b><span>{f.meta}</span></div>
              </div>
              <div className="wv-class-arrow" aria-hidden="true">
                <svg width="22" height="14" viewBox="0 0 22 14" fill="none"><path d="M0 7h20m0 0L14 1m6 6-6 6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </div>
              <div className="wv-class-outs">
                {matches[i].map((m) => (
                  <div key={m.type} className="wv-class-out">
                    <span className="wv-class-bar" />
                    <div><b>{m.type}</b><span>{m.pages}</span></div>
                    <span className="conf conf--ok">{m.conf}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function ModelsView() {
  const rows = [
    { name: "Invoice model", docs: "4,210 documents", acc: "96.4%", retrain: "68%", status: "Active" },
    { name: "Claims model", docs: "1,832 documents", acc: "91.8%", retrain: "44%", status: "Active" },
    { name: "Bill of Lading model", docs: "622 documents", acc: "94.1%", retrain: "82%", status: "Active" },
    { name: "Purchase Order model", docs: "1,148 documents", acc: "93.2%", retrain: "51%", status: "Active" },
  ];
  return (
    <div className="wv">
      <div className="wv-block">
        <div className="wv-block__head"><span>Trained models</span><span className="wv-block__meta">14 total, 4 shown</span></div>
        <div className="wv-models">
          <div className="wv-models__head">
            <span>Model</span><span>Volume</span><span>Accuracy</span><span>Retrain queue</span><span>Status</span>
          </div>
          {rows.map((r) => (
            <div className="wv-models__row" key={r.name}>
              <div className="wv-models__name"><b>{r.name}</b><span>{r.docs}</span></div>
              <div className="wv-models__cell wv-models__cell--mono">{r.docs.split(" ")[0]}</div>
              <div className="wv-models__cell wv-models__cell--num">{r.acc}</div>
              <div className="wv-models__bar"><i style={{width:r.retrain}} /></div>
              <div className="wv-models__cell"><span className="statusdot">{r.status}</span></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const VIEWS = {
  dashboard: DashboardView,
  training: TrainingView,
  classify: ClassifyView,
  models: ModelsView,
  settings: TrainingView, // disabled in UI
};

export default function Workspace() {
  const [active, setActive] = useState("training");
  const View = VIEWS[active] || TrainingView;

  const grouped = NAV.reduce((acc, item) => {
    (acc[item.group] = acc[item.group] || []).push(item);
    return acc;
  }, {});

  return (
    <div className="appshell" aria-label="Docket application workspace example">
      <aside className="appshell__side">
        <div className="appshell__brand"><b>Docket</b><small>IDP</small></div>
        {Object.entries(grouped).map(([group, items]) => (
          <div key={group}>
            <div className="appshell__group">{group}</div>
            {items.map((it) => (
              <button
                key={it.id}
                type="button"
                className={`appshell__item${active === it.id ? " active" : ""}`}
                onClick={() => !it.disabled && setActive(it.id)}
                disabled={it.disabled}
                data-testid={`workspace-nav-${it.id}`}
                aria-current={active === it.id ? "page" : undefined}
              >
                <it.Ic />
                {it.label}
              </button>
            ))}
          </div>
        ))}
      </aside>
      <div className="appshell__main">
        <div className="appshell__topbar">
          <span className="appshell__title">{TITLES[active]}</span>
          <span className="appshell__search">⌕ &nbsp; Search models, documents</span>
        </div>
        <div className="appshell__viewport" key={active} data-testid={`workspace-view-${active}`}>
          <View />
        </div>
      </div>
    </div>
  );
}
